import { Card, CardContent, CardMedia, TextField } from '@mui/material';
import BoxDrawer from 'components/BoxDrawer';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { FeedItemApprovalWorkFlow } from 'models/ApiModels';
import * as React from 'react';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    title: string;
    workflowStep: FeedItemApprovalWorkFlow;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WorkFlowMessageDrawer: React.FC<IProps> = (props) => {
    const { onClose, title, workflowStep } = props;
    return (
        <BoxDrawer
            open
            title={title}
            onClose={() => { onClose(); }}
        >
            <MuiPaper dense elevation={0}>
                <Card>

                    <CardMedia image={workflowStep.approver.thumbnailUrl} />

                    <CardContent>

                        <TextField
                            fullWidth
                            multiline
                            disabled
                            rows={10}
                            value={workflowStep.comment}
                        />

                    </CardContent>

                </Card>
            </MuiPaper>
        </BoxDrawer>
    );
};

export default WorkFlowMessageDrawer;